export default "__VITE_ASSET__MQ4DYBIi__"